<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SqOkW/tc-custom/9781452163079.jpg?1718106412938" alt="This image is the cover for the book Happy Houseplants"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Happy Houseplants
      </h1>
      <p class="bookDescription body article font2">
        <b>Enhance your home décor with this guide to choosing and caring for indoor plants, with information on thirty common, easy-to-grow varieties.</b><br/>  <br/> For anyone who has longed for a garden of their own—whether a city dweller or one with less-than-green thumbs—this is a handy little guide to growing and maintaining houseplants. Cheerful and informative, <i>Happy Houseplants</i> will guide any budding indoor botanist through a bevy of topics, from soil and water to light and fertilizer. With beautiful illustrations accompanying thirty different profiles of plants, from the easygoing Air Plant to the striking Zebra Cactus, this nifty book is the perfect gift for anyone looking to bring a piece of the outdoors inside. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Angela Staehling
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1db5cdc1